import { ArrowUpRight } from "lucide-react";
import { FINAL } from "@/lib/content";
import { scrollToId } from "@/lib/site";
import { Kinetic, Reveal } from "@/components/Kinetic";
import { Logo } from "@/components/Logo";

export default function FinalCta() {
  return (
    <section aria-labelledby="final-cta-heading" data-testid="final-cta-section" className="bg-white pb-24 lg:pb-36">
      <div className="wrap">
        <div className="relative overflow-hidden rounded-[36px] bg-emerald px-6 py-16 text-white sm:px-12 sm:py-20 lg:px-20 lg:py-28">
          <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full border-[28px] border-white/10" />
          <div aria-hidden="true" className="pointer-events-none absolute -bottom-32 right-[20%] h-64 w-64 rounded-full bg-emerald-deep" />
          <div className="relative max-w-4xl">
            <Kinetic
              text={FINAL.headline}
              testId="final-cta-heading"
              className="display text-4xl leading-[0.95] sm:text-5xl lg:text-[76px]"
            />
            <Reveal delay={0.2}>
              <p className="mt-7 max-w-xl text-base leading-relaxed text-white/85 sm:text-lg">{FINAL.supporting}</p>
            </Reveal>
            <Reveal delay={0.3}>
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); scrollToId("contact"); }}
                data-testid="final-cta-start-project"
                className="btn mt-10 bg-white text-emerald-deep hover:bg-ink hover:text-white"
              >
                START YOUR PROJECT <ArrowUpRight className="btn-arrow h-4 w-4" />
              </a>
            </Reveal>
          </div>
          <div className="relative mt-20 flex flex-col gap-6 border-t border-white/20 pt-8 sm:flex-row sm:items-end sm:justify-between">
            <span data-testid="final-cta-brand"><Logo tone="white" size={40} /></span>
            <span data-testid="final-cta-domain" className="whitespace-nowrap font-display text-[clamp(24px,8.4vw,30px)] font-extrabold tracking-tight underline decoration-white/40 decoration-[3px] underline-offset-[10px] sm:text-5xl">
              www.faizu<span className="text-emerald-dot">.net</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
